module.exports = __webpack_public_path__ + "img/close-icon.aa049c8f.svg";